import { Link } from "react-router-dom";
import { categories, siteInfo } from "@/mocks/articles";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 w-full bg-primary-950 text-background-100">
      <div className="mx-auto grid w-full gap-8 px-4 py-12 md:grid-cols-2 md:px-8 md:py-14 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 font-label text-base font-600 text-background-50">
              17
            </span>
            <span className="font-heading text-lg font-700 tracking-wide text-background-50">17爆料网</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-background-200">
            专注网络传言核实与追踪，汇总当事人澄清、后续回应与反转进展。
          </p>
          <p className="mt-4 flex items-center gap-2 text-sm text-background-200">
            <i className="ri-mail-line text-primary-300"></i>
            {siteInfo.email}
          </p>
        </div>

        <div>
          <h2 className="font-heading text-sm font-600 text-background-50">浏览栏目</h2>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li>
              <Link to="/" className="text-background-200 transition-colors hover:text-primary-300">
                首页
              </Link>
            </li>
            <li>
              <Link to="/verify" className="text-background-200 transition-colors hover:text-primary-300">
                真假鉴定专区
              </Link>
            </li>
            <li>
              <Link to="/verify?verdict=出现反转" className="text-background-200 transition-colors hover:text-primary-300">
                反转追踪
              </Link>
            </li>
            <li>
              <Link to="/verify?verdict=打脸现场" className="text-background-200 transition-colors hover:text-primary-300">
                打脸现场
              </Link>
            </li>
            <li>
              <Link to="/about" className="text-background-200 transition-colors hover:text-primary-300">
                关于我们
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h2 className="font-heading text-sm font-600 text-background-50">鉴定主题</h2>
          <ul className="mt-4 space-y-2.5 text-sm">
            {categories.slice(0, 5).map((c) => (
              <li key={c.key}>
                <Link
                  to={`/verify?category=${c.key}`}
                  className="text-background-200 transition-colors hover:text-primary-300"
                >
                  {c.key}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h2 className="font-heading text-sm font-600 text-background-50">线索与更正</h2>
          <p className="mt-4 text-sm leading-relaxed text-background-200">
            发现结论有误，或想提供可核实线索，欢迎随时联系我们。
          </p>
          <p className="mt-3 flex items-center gap-2 text-sm text-background-200">
            <i className="ri-inbox-archive-line text-primary-300"></i>
            {siteInfo.submitEmail}
          </p>
          <Link
            to="/#submit"
            className="mt-5 inline-block whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-500 text-background-50 transition-colors hover:bg-primary-400"
          >
            提交线索
          </Link>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="mx-auto flex w-full flex-col gap-3 px-4 py-6 text-xs text-background-300 md:flex-row md:items-center md:justify-between md:px-8">
          <p>© {year} 17爆料网. 保留所有权利。</p>
          <p className="leading-relaxed">
            本站鉴定结论基于公开信息整理，供参考交流；如涉及侵权或内容有误，欢迎联系更正。
          </p>
        </div>
      </div>
    </footer>
  );
}